import { createUppyInstance } from '~/common/utils/uppy.util.js';
import { ANNOTATION_TYPES } from '~/plans/constants';
import { extractAttrFromXML, getPDFWithAnnotations, initiateStandalonePDFTron } from '~/plans/utils/helper';

function uploadFileToStorage(file) {
  return new Promise((resolve) => {
    const uppy = createUppyInstance({
      attachment_config: {
        meta: {
          service: 'dms',
          id: 'upload',
        },
      },
      complete_cb: result => (resolve(result.successful[0])),
    });
    uppy.addFiles([file]);
  });
}

function filterStampAnnotations(annotations) {
  return annotations.filter((annot) => {
    const annot_subject = extractAttrFromXML(annot.annotation_data, 'subject');
    return [ANNOTATION_TYPES.DOC_STAMP, ANNOTATION_TYPES.QR_STAMP].includes(annot_subject);
  });
}

export function useDMSStamp(transmittal_store) {
  async function fetchAnnotations(document_details) {
    const annotation_query = {
      element: document_details.uid,
      version: document_details.versions.at(-1).uid,
    };
    const annotations_response = await transmittal_store.fetch_annotations(annotation_query);
    const filtered_stamp_annots = filterStampAnnotations(annotations_response.data.annotations);
    return filtered_stamp_annots;
  }

  async function flattenAnnotationsInDocument(document_details) {
    const filtered_stamp_annots = await fetchAnnotations(document_details);
    if (filtered_stamp_annots.length === 0)
      return;
    // Get the flattened stamp annotated PDF bytes
    const pdf_bytes = await getPDFWithAnnotations(document_details.presigned_url, filtered_stamp_annots, { flatten_annotations: true });
    const blob = new Blob([pdf_bytes], { type: 'application/pdf' });
    const file = new File([blob], document_details.file_name, { type: 'application/pdf' });
    return { file, uid: document_details.uid, version: document_details.versions.at(-1).uid };
  }

  async function flatten(filtered_documents) {
    await initiateStandalonePDFTron();
    const files = await Promise.all(filtered_documents.map(flattenAnnotationsInDocument));
    await Promise.all(files.filter(d => d).map(async ({ file, uid }) => {
      const results = await uploadFileToStorage(file);
      const service_object = results.data.service_object;
      await transmittal_store.replace_revision({
        transmittal_uid: transmittal_store.transmittal.uid,
        transmittals: {
          documents: [{
            uid,
            service_object,
            stamped: true,
          }],
        },
      });
    }));
  }

  return {
    flatten,
    fetchAnnotations,
    filterStampAnnotations,
    uploadFileToStorage,
  };
}
